import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class CreditMemoService {

  constructor(private crudService: CrudService) { }

  GetAllPostedInvoiceNoByVNo(VendorNo:string): Observable<any>{
    return this.crudService.get<any>('CreditMemo/GetAllPostedInvoiceByVendorNo?VendorNo='+VendorNo);
  }

  GetPostedInvoiceDetails(PostedInvoiceNo:string): Observable<any>{
    return this.crudService.get<any>('CreditMemo/GetPostedInvoiceDetails?PostedInvoiceNo='+PostedInvoiceNo);
  }


  GetAllPreInvoiceNoByVNo(VendorNo:string): Observable<any>{
    return this.crudService.get<any>('CreditMemo/GetAllPreInvoiceByVendorNo?VendorNo='+VendorNo);
  }

  GetPreInvoiceDetails(PreInvoiceNo:string): Observable<any>{
    return this.crudService.get<any>('CreditMemo/GetPreInvoiceDetails?PreInvoiceNo='+PreInvoiceNo);
  }



  GetAddressCodes(): Observable<any>{
    return this.crudService.get<any>('CreditMemo/GetAddressCodes');
  }

  SaveCreditMemo(obj:any): Observable<any>{ 
    return this.crudService.post('CreditMemo/SaveCreditMemoDetails',obj);
  }

}
